export default "__VITE_ASSET__gpwPGV7c__"